<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="USER LIST"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void (0)"
          class="icon-pencil1"
          style="margin-right: 20px; color: #3a3f63"
          @click="handleEdit(tableRow.row)"
        />
        <a
          href="javascript:void (0)"
          :class="tableRow.row.status === 1 ? 'icon-locked' : 'icon-unlock1'"
          style="color: #3a3f63"
          @click="handleActionBtn(tableRow.row)"
        />
      </template>
    </table-view>

    <!-- 新增弹窗   -->
    <el-dialog
      :visible.sync="visible"
      title="Add"
      width="800px"
      @close="handleCancel"
      :close-on-click-modal="false"
    >
      <el-card shadow="never">
        <el-form :model="form" ref="form" label-position="top" :rules="rules">
          <el-form-item label="First Name" prop="name">
            <el-input style="width: 100%" v-model="form.name" />
          </el-form-item>
          <el-form-item label="Last Name" prop="lastName">
            <el-input style="width: 100%" v-model="form.lastName" />
          </el-form-item>
          <el-form-item label="IT Code" prop="username">
            <el-input style="width: 100%" v-model="form.username" />
          </el-form-item>
          <el-form-item label="E-mail" prop="email">
            <el-input style="width: 100%" v-model="form.email" />
          </el-form-item>
          <el-form-item label="Role Source" prop="source">
            <el-select v-model="form.source" style="width: 100%">
              <el-option label="Trade" :value="1" />
              <el-option label="CSS" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="Access Role Assignments" prop="roleIds">
            <div>
              <el-checkbox-group v-model="form.roleIds">
                <el-row>
                  <el-col :span="12" v-for="item in roleList" :key="item.id">
                    <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="Business Role Assignments" prop="roleIds">
            <div>
              <!-- select all -->
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
              >
                Select All
              </el-checkbox>
              <el-checkbox-group
                v-model="form.businessRoleIds"
                @change="handleCheckedCitiesChange"
              >
                <el-row>
                  <el-col
                    :span="12"
                    v-for="item in businessRoleList"
                    :key="item.id"
                  >
                    <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </div>
          </el-form-item>
        </el-form>
      </el-card>
      <template slot="footer">
        <customize-button
          class="clear-btn"
          style="margin-right: 20px"
          @click="handleCancel"
        >
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleSaveBtn">
          Save
        </customize-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getSelectList } from '@/api'
import {
  getTableData,
  getRoleList,
  updateAndAdd,
  activationUser,
  freezeUser,
  getBusinessRoleList,
} from './api'

export default {
  data() {
    const searchModel = [
      {
        label: 'ITCode',
        type: 'input',
        key: 'username',
      },
      {
        label: 'User Status',
        type: 'select',
        placeholder: 'All',
        key: 'status',
        selectList: [
          {
            name: 'Active',
            id: 1,
          },
          {
            name: 'Inactive',
            id: 2,
          },
        ],
      },
      {
        label: 'Role Source',
        type: 'select',
        placeholder: 'All',
        key: 'source',
        selectList: [
          {
            name: 'Trade',
            id: 1,
          },
          {
            name: 'CSS',
            id: 2,
          },
        ],
      },
    ]
    const tableModel = [
      {
        width: 200,
        label: 'First Name',
        prop: 'name',
      },
      {
        width: 200,
        label: 'Last Name',
        prop: 'lastName',
      },
      {
        width: 120,
        label: 'IT Code',
        prop: 'username',
      },
      {
        minWidth: 150,
        label: 'Last Login Time',
        prop: 'loginTime',
      },
      {
        width: 160,
        label: 'Role Source',
        prop: 'sourceStr',
      },
      {
        width: 150,
        label: 'Status',
        prop: 'statusStr',
      },
      {
        width: 120,
        label: 'Action',
        slotName: 'action',
      },
    ]
    return {
      // 全选
      checkAll: false,
      searchModel,
      tableModel,
      tableData: [],
      pages: {},
      visible: false,
      form: {
        name: '',
        lastName: '',
        username: '',
        email: '',
        roleIds: [],
        businessRoleIds: [],
        source: '',
      },
      rules: {
        name: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        lastName: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        username: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        email: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
        // source: [
        //   { required: true, message: 'Can not be empty!', trigger: 'change' },
        // ],
      },
      roleList: [],
      businessRoleList: [],
    }
  },
  mounted() {
    this.initTable()
    this._getRoleList()
    this._getBusinessRoleList()
  },
  computed: {
    isIndeterminate() {
      return this.form.businessRoleIds.length === 0
        ? null
        : this.form.businessRoleIds.length !== this.businessRoleList.length
    },
  },
  methods: {
    // 全选功能
    handleCheckAllChange(val) {
      this.form.businessRoleIds = val
        ? this.businessRoleList.map(c => c.id)
        : []
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.businessRoleList.length
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getSelectList(typeMark) {
      try {
        return await getSelectList(typeMark)
      } catch (err) {
        console.error(err)
      }
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    handleCancel() {
      this.visible = false
      this.formId = ''
      this.$refs.form.clearValidate()
      this.$refs.form.resetFields()
    },
    async handleSaveBtn() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        await this._updateAndAdd({ ...this.form, id: this.formId })
      }
    },
    async _updateAndAdd(params) {
      try {
        await updateAndAdd(params)
        this.$message.success('success')
        this.initTable()
        this.visible = false
      } catch (err) {
        console.error(err)
      }
    },
    handleTitleActionBtn() {
      this.checkAll = false
      this.form.businessRoleIds = []
      this.visible = true
    },
    async _getRoleList() {
      try {
        this.roleList = await getRoleList()
      } catch (err) {
        console.error(err)
      }
    },
    async _getBusinessRoleList() {
      try {
        this.businessRoleList = await getBusinessRoleList()
      } catch (err) {
        console.error(err)
      }
    },
    handleEdit(row) {
      this.visible = true
      this.formId = row.id
      this.$nextTick(() => {
        const obj = this.$cloneDeep(row)
        obj.roleIds = obj.roleNames.map(item => item.id)
        obj.businessRoleIds = obj.businessRoleVOS.map(item => item.id)
        Object.keys(this.form).forEach(key => (this.form[key] = obj[key]))
      })
    },
    async handleActionBtn({ status, id }) {
      try {
        // status:  1: 激活 2：冻结
        if (status === 1) {
          // 需要冻结
          await freezeUser(id)
        } else {
          await activationUser(id)
        }
        this.initTable()
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
